import { Pipe, PipeTransform } from '@angular/core';
import {IFoodGroupIngredient} from '../../models/food-group';

@Pipe({
  name: 'hasAnyDislikeIngredient'
})
export class HasAnyDislikeIngredientPipe implements PipeTransform {

  transform(ingredients: Partial<IFoodGroupIngredient>[]): boolean {
    return ingredients.some((ingredient: IFoodGroupIngredient) => ingredient.isDislike);
  }

}
